// Height of the timeline modal, used to offset PoiDialog above it
export const TIMELINE_MODAL_HEIGHT = {
  mobile: 70,
  desktop: 158,
} as const;

// Legend strip heights; the mobile one also pushes the map controls down
export const TIMELINE_MOBILE_LEGEND_HEIGHT = 36;
export const TIMELINE_DESKTOP_LEGEND_HEIGHT = 30;
